import React from 'react';
import PageHelmet from '../component/common/Helmet';
import Header from '../component/header/HeaderSecondary';
import Footer from '../component/footer/FooterTwo';
import ContactOne from './contact/ContactOne';
import ScrollToTop from '../component/common/ScrollTop';
import './Podminky.css';

function LegalPage({ title, children }) {
    return <>
        <PageHelmet pageTitle={title} />
        <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
        <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--1" data-black-overlay="7">
            <div className="container">
                <div className="blog-single-page-title text-center pt--100">
                    <h2 className="title theme-gradient">{title}</h2>
                </div>
            </div>
        </div>
        <div className="rn-blog-details pt--110 pb--70 bg_color--1">
            <div className="container">
                <div className="inner-wrapper"><div className="inner">{children}</div></div>
            </div>
        </div>
        <div id="contact" className="fix">
            <div className="rn-contact-area ptb--120 bg_color--1"><ContactOne /></div>
        </div>
        <div className="backto-top"><ScrollToTop /></div>
        <Footer />
    </>;
}

export default LegalPage;
